import { getLocale } from "../runtime";

const da_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Gratis fragt over 599kr`
};

const en_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Free shipping over 99£`
};

const es_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Envío gratis por encima de 599€`
};

const fi_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Ilmainen toimitus yli 599€`
};

const nb_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fri frakt over 599kr`
};

const sv_productusp4 = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Fri frakt över 599kr`
};

const productusp4 = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "da") return da_productusp4(inputs)
	if (locale === "en") return en_productusp4(inputs)
	if (locale === "es") return es_productusp4(inputs)
	if (locale === "fi") return fi_productusp4(inputs)
	if (locale === "nb") return nb_productusp4(inputs)
	if (locale === "sv") return sv_productusp4(inputs)
	return "productUsp4";
};

export { productusp4 as "productUsp4" };